import { render, staticRenderFns } from "./PersonalizationModal.vue?vue&type=template&id=756920e2&"
import script from "./PersonalizationModal.vue?vue&type=script&lang=ts&"
export * from "./PersonalizationModal.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalizationModal.vue?vue&type=style&index=0&id=756920e2&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports